import React from 'react';
import PropTypes from 'prop-types';
import { TouchableWithoutFeedback as TouchableWithoutFeedbackRN } from 'react-native';
import View from '../View';

const TouchableWithoutFeedback = ({
  onPress,
  ...props
}) => /*#__PURE__*/React.createElement(TouchableWithoutFeedbackRN, {
  onPress: onPress
}, /*#__PURE__*/React.createElement(View, props));

TouchableWithoutFeedback.propTypes = {
  onPress: PropTypes.func
};
TouchableWithoutFeedback.defaultProps = {
  onPress: undefined
};
export default TouchableWithoutFeedback;